<div class="fixed-header">
  <button (click)="closePantherWebView()" *ngIf="headerService?.isPantherTablet" class="panther-close-button btn btn-default">Back to Panther
    <img style="
    height: 15px;
    margin-top: -2px;
    margin-left: 5px;
" src="assets/images/export-icon.png" />
  </button>
<div class="container-fluid header-container-fluid" *ngIf="displayHeader">
  <!-- Header Row with Logo and Title Only -->
  <div class="row header-row">
    <div class="box col-12">
      <div class="logo-container" routerLink="/">
        <img class="logo" src="assets/images/Logo-NRS.png" alt="nrs logo" />
      </div>
      <div class="header-text-container my-auto">
        <div class="header3 bold" [innerHtml]="pageTitle"></div>
      </div>
    </div>
  </div>
  
  <!-- Stepper Progress Bar - Horizontal with Labels Right -->
  <div
    #stepperContainer
    class="stepper-container"
    *ngIf="!isSuccessPage && step > 0"
    (mousedown)="onStepperMouseDown($event)"
    (dragstart)="$event.preventDefault()">
    <div class="stepper-wrapper">
      <ng-container *ngFor="let stepLabel of stepLabels; let i = index; let last = last">
        <div
          #stepperItem
          class="stepper-item"
          [class.completed]="i <= maxVisitedStepIndex"
          [class.active]="i + 1 === step"
          [class.upcoming]="i > maxVisitedStepIndex"
          [class.clickable]="i <= maxVisitedStepIndex && !isStepDisabled(i) && !navigationLocked"
          [class.disabled]="isStepDisabled(i) || navigationLocked"
          [attr.aria-disabled]="isStepDisabled(i) || navigationLocked"
          (click)="onStepClick(i, $event)">
          <div class="step-circle">
            <img *ngIf="i <= maxVisitedStepIndex && i + 1 !== step" class="checkmark-img" src="assets/images/check_24dp.svg" alt="completed" />
            <span *ngIf="i > maxVisitedStepIndex || i + 1 === step">{{ i + 1 }}</span>
          </div>
          <div class="step-label">{{ stepLabel }}</div>
        </div>
        <div class="step-connector" *ngIf="!last" [class.completed]="i < maxVisitedStepIndex"></div>
      </ng-container>
    </div>
  </div>
</div>

<div class="container-fluid header-container-fluid" *ngIf="waringDisplayHeader">
  <div class="row header-row">
    <div class="box col-md-9 col-sm-9">
      <div class="logo-container">
        <img class="logo" src="assets/images/nrs-logo-black2.png" alt="nrs logo" />
      </div>
    </div>
  </div>
</div>
</div>

<!-- Fixed Bottom Navigation Bar -->
<div class="fixed-bottom-nav" *ngIf="displayHeader && displayNavButtons && !isSuccessPage">
  <div class="bottom-nav-container">
    <div class="bottom-nav-left">
      <span class="bottom-nav-subtitle" [innerHtml]="pageSubTitle"></span>
    </div>
    <div class="bottom-nav-buttons">
      <button
        class="btn shadow-sm app-nav-buttons nav-button-outline"
        type="button"
        (click)="onClickPrevious()"
        *ngIf="!hideBackbutton && previousPage"
        [disabled]="(isAgreementPage && disableBackBtn) || navigationLocked"
      >
        <img class="backArrow" src="assets/images/chevron-left.svg" alt="back button" />
        Back
      </button>
      <button
        *ngIf="!hideNextButton"
        class="btn ms-3 shadow-sm app-nav-buttons nav-button-primary"
        type="button"
        [disabled]="(bankPage || paymentPlansPage) && disableNxtBtn"
        (click)="onClickNext()"
      >
        <span>Next</span>
        <img class="nextArrow" src="assets/images/chevron-right.svg" alt="next button" />
      </button>
    </div>
  </div>
</div>

<!-- Success Page Navigation (separate handling) -->
<div class="fixed-bottom-nav" *ngIf="displayHeader && displayNavButtons && isSuccessPage">
  <div class="bottom-nav-container">
    <div class="bottom-nav-left">
      <span class="bottom-nav-subtitle"></span>
    </div>
    <div class="bottom-nav-buttons">
      <button
        class="btn shadow-sm app-nav-buttons nav-button-primary"
        type="button"
        (click)="onClickNext()"
      >
        Go to dashboard
        <img class="nextArrow" src="assets/images/chevron-right.svg" alt="next button" />
      </button>
    </div>
  </div>
</div>

<!-- Unsaved-changes prompt shown when leaving a dirty page via the stepper -->
<ng-template #unsavedChangesModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      <i class="text-warning bi bi-exclamation-triangle-fill"></i> Unsaved changes
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body">
    <p>You have unsaved changes on this page. Do you want to save them before leaving?</p>
  </div>
  <div class="modal-footer unsaved-changes-footer">
    <button type="button" class="btn app-nav-buttons nav-button-outline" (click)="modal.close('discard')">Discard</button>
    <button type="button" class="btn app-nav-buttons nav-button-primary" (click)="modal.close('save')">Save</button>
  </div>
</ng-template>
